import { ValidationError } from "../errors";
import { SerializerExtensions, serializerExtensions } from "../extensions";
import { Serializer } from "../serializer";

export const string: Serializer<string> & SerializerExtensions<string> = {
  serialize: (str: string) => {
    if (typeof str !== "string") throw new ValidationError(`Value is not a string (${typeof str})`);
    return str;
  },
  deserialize: (raw: any) => {
    if (typeof raw !== "string") throw new ValidationError(`Value is not a string (${typeof raw})`);
    return raw;
  },
  ...serializerExtensions(),
};
